import { GtmEventAction, GtmLoginMethod, GtmRegistrationType } from "@obg/gtm.types/adaptive";
import { CoreUiInteractionEvent, Jurisdiction } from "@obg/ngx.core";

import { REGISTER_MESSAGE_CODE } from "../registration/registration.const";

export const enum RegistrationTelemetryEventName {
	FailedRegistration = "FailedRegistration",
	ConfirmedRegistration = "ConfirmedRegistration",
	VerifiedRegistration = "VerifiedRegistration",
	RegistrationFieldChange = "RegistrationFieldChange",
	RegistrationSubmitted = "RegistrationSubmitted",
	OpenRegPage = "OpenRegPage",
	TrustlyClose = "TrustlyClose",
	TrustlyOpen = "TrustlyOpen",
	ChangeRegistrationType = "ChangeRegistrationType",
	CreateAccountClick = "CreateAccountClick",
	RegistrationLoginClick = "RegistrationLoginClick",
	InvalidCPF = "RegistrationInvalidCPF",
	NavigationContinue = "Registration Navigation Continue",
}

export const enum DgaAuthStatus {
	Failed = "Failed",
	Success = "Success",
}

export const enum DgaRegistrationTelemetryEvent {
	CreateAccountClick = "CreateAccountClick",
	EditDetailsClick = "EditDetailsClick",
}

export const enum SmartIdRegistrationTelemetryEvent {
	SmartIDFormClick = "SmartIDFormClick",
	SmartIDRegVerificationOpen = "SmartIDRegVerificationOpen",
	SmartIDRegVerificationSuccess = "SmartIDRegVerificationSuccess",
	SmartIDRegVerificationFailed = "SmartIDRegVerificationFailed",
	SmartIDRegVerificationErrorClick = "SmartIDRegVerificationErrorClick",
}

export const enum SmartIdRegistrationTelemetryItemClicked {
	SmartIdSelected = "Register with Smart-ID",
	SmartIdNotSelected = "No Smart-ID Registration",
	EnterDetailsClick = "Enter Details",
	TryAgainClick = "Try Again",
}

export const enum SmartIdAuthStatus {
	Failed = "Failed",
	Success = "Success",
}

export type CommonUiRegistrationEvent =
	| RegistrationTelemetryEventName
	| DgaRegistrationTelemetryEvent
	| SmartIdRegistrationTelemetryEvent;
export type CommonUiInteractionEvent = CoreUiInteractionEvent | CommonUiRegistrationEvent;
export type RegisterProvider = "Trustly";

export interface TelemetryFieldEventPayload {
	field: string;
	registrationType?: Jurisdiction | GtmLoginMethod;
	registrationMethod?: GtmRegistrationType;
	registrationStep?: number;
}

export interface TelemetryEventPayload {
	event: RegistrationTelemetryEventName | GtmEventAction | SmartIdRegistrationTelemetryEvent;
	registrationType?: Jurisdiction | GtmLoginMethod;
	status?: string;
	registrationMethod?: GtmRegistrationType;
}

export interface TelemetryErrorPayload {
	reasons?: string[];
	code?: string;
}

export const REGISTER_MESSAGE_CODE_TO_GTM_ERROR_MESSAGE = {
	[REGISTER_MESSAGE_CODE.nonUniqueAccount]: "Registration from non-unique account",
	[REGISTER_MESSAGE_CODE.invalidEmail]: "Email invalid",
	[REGISTER_MESSAGE_CODE.unknownError]: "Unknown error event from API",
	[REGISTER_MESSAGE_CODE.requiredParameter]: "Required parameter is missing",
};
